/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable arrow-body-style */
import { Line } from 'react-chartjs-2';
import { useMemo } from 'react';
import { $detail } from 'signals/global.signals';
import { getAnalyticsDataSetSettings, getViewsDataAsTimeSeries } from 'components/views/FounderRoom/_helpers/founderRoom.utils';
import { VIEWS_CHART_OPTIONS } from 'components/views/FounderRoom/_helpers/founderRoom.consts';
import SimpleCard from 'components/global/SimpleCard';
import SignalTable from 'components/global/SignalTable/SignalTable';
import RoomAnalyticsViewsRow from 'components/views/FounderRoom/_components/FounderRoomAnalyticsViewsRow';

const FounderRoomAnalytics = () => {
  const chartData = useMemo(() => {
    const views = $detail.value.roomViews || [];
    if (views.length === 0) {
      return { datasets: [{ data: [], ...getAnalyticsDataSetSettings() }] };
    }
    const dataPoints = getViewsDataAsTimeSeries(views) || [];
    return {
      datasets: [{ data: dataPoints, ...getAnalyticsDataSetSettings() }],
    };
  }, [$detail.value.roomViews]);

  return (
    <div>
      <SimpleCard>
        <div className="p-24" style={{ width: '100%', height: '300px', backgroundColor: 'transparent' }}>
          <Line data={chartData} options={VIEWS_CHART_OPTIONS} />
        </div>
        <SignalTable
          rows={RoomAnalyticsViewsRow({ data: $detail.value.roomViews || [] })}
          headers={[
            { value: 'Date', key: 'createdAt' },
            { value: 'Organization', key: 'orgName' },
            { value: 'Last Name', key: 'lastName' },
            { value: 'First Name', key: 'firstName' },
            { value: 'Email', key: 'email' },
          ]}
          className="mt-24"
          pagination={false}
          noDataMessage="No data available"
        />
      </SimpleCard>
    </div>
  );
};

export default FounderRoomAnalytics;
